<template lang="pug">
md-table-card.card
  form(novalidate='', @submit.stop.prevent='search')
    .filters
      md-layout(md-align='end')
        md-layout.searchContainer(md-flex='33', md-align='end')
          md-layout
            md-input-container
              label Search
              md-input(v-model.lazy='searchText',  v-on:keypress.enter="search()" )
          md-layout(md-flex='15', v-if='searchText != ""')
            md-button.clean-search-label-btn.md-icon-button.btn(@click='cleanSearchText')
              md-icon.icon(md-iconset="fa fa-trash-alt")
          md-layout(md-flex='10')
            md-button.md-icon-button.btn(type='submit', :disabled='loading')
              md-icon.icon(md-iconset="fa fa-search")

  stitch-loader(:loading='loading', :size='40')
    .distributions(v-if='distributions.length > 0')
      div.titleLine.styleRow
        p.rowElements.sortable(@click = "onSort('name')") Name {{sort.name === 'name' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
        p.rowElements Status
        p.rowElements.sortable(@click = "onSort('lastUpdated')") Updated {{sort.name === 'lastUpdated' ? sort.type === 'desc' ? '&darr;' : '&uarr;' : ''}}
        p.rowElements
      div.styleRow.colorHover(v-for='distribution in distributions', :key='distribution._id')
        div.rowElements {{distribution.name}}
        div.rowElements(v-if="distribution.status === 'public'") live
        div.rowElements(v-else) {{ distribution.status }}
        div.rowElements {{ distribution.lastUpdated | moment('from') }}
        div.rowElements
          md-button#editBtn.md-icon-button.md-raised.btn(@click='editDistribution(distribution._id)')
            md-icon.icon(md-iconset="fa fa-pencil-alt")
          md-button#exportBtn.md-icon-button.md-raised.btn(@click='exportDistributionItems(distribution)', :disabled='exportingId === distribution._id')
            md-icon.icon(md-iconset="fa fa-download")

      md-table-pagination(
        :md-size='currentPagination.size',
        :md-total='totalDistributions',
        :md-page='currentPagination.page',
        md-label='Distributions',
        md-separator='of',
        :md-page-options='[10, 25, 50, 100]',
        @pagination='onPageChanged'
      )

    div#no-results(v-else)
      div.message
        md-icon.md-accent(md-iconset="fa fa-exclamation-circle",)
        | No items to show
</template>

<script>
import distributionService from '../../services/distributionService';
import stitchLoader from '../../shared-components/Loader';

export default {
  components: {
    stitchLoader
  },
  data() {
    return {
      distributions: [],
      totalDistributions: null,
      loading: false,
      currentPagination: {
        page: 1,
        size: 10
      },
      sort: {
        name: 'lastUpdated',
        type: 'desc'
      },
      searchText: '',
      exportingId: null
    };
  },
  computed: {
    searchParams() {
      const params = {
        offset: (this.searchText || this.currentPagination.page == 1) ? 0 : this.currentPagination.size * (this.currentPagination.page - 1),
        limit: this.$session.get("limitPaginationDistributions") || this.currentPagination.size,
        sortBy: this.sort.name,
        sortOrder: this.sort.type
      };
      if (this.searchText) {
        Object.assign(params, { name: this.searchText });
      }

      // This check is to prevent the offset isn't larger than the total items.
      if (this.totalDistributions != null && params.offset >= this.totalDistributions && (params.offset !== 0 && this.totalDistributions !== 0)) {
        params.offset = 0
      }

      return params;
    }
  },
  methods: {
    onPageChanged(paginationParams) {
      this.currentPagination = paginationParams;
      this.$session.set("iWasInPageDistributions", paginationParams.page);
      this.$session.set("limitPaginationDistributions", paginationParams.size);
      this.search();
    },
    onSort(sortParams) {
      this.sort.name = sortParams;
      this.sort.type = this.sort.type === 'desc' ? 'asc' : 'desc';
      this.search();
    },
    search() {
      this.loading = true;
      distributionService.getList(this.searchParams)
        .then((response) => {
          this.distributions = response.data.distributions;
          this.totalDistributions = response.data.total;
        })
        .catch((error) => {
          console.error('Error while retrieving the list of distributions', error);
        })
        .then(() => {
          this.loading = false;
        });
    },
    editDistribution(distributionId) {
      this.$router.push({
        name: 'EditDistribution',
        params: {
          id: distributionId
        }
      });
    },
    cleanSearchText() {
      this.searchText = '';
      this.search()
    },
    exportDistributionItems(distribution) {
      this.exportingId = distribution._id;
      distributionService.exportItems(distribution._id)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const hiddenLink = document.createElement('a');
          document.body.appendChild(hiddenLink);
          hiddenLink.style.display = 'none';
          hiddenLink.href = url;
          hiddenLink.download = `${distribution.name}-items.csv`;
          hiddenLink.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(hiddenLink);
        })
        .catch((error) => {
          console.error('Error while exporting distribution items', error);
        })
        .then(() => {
          this.exportingId = null;
        });
    },
  },
  mounted() {
    this.$session.set("limitPagination", this.currentPagination.size);
    this.$session.set("limitPaginationDomains", this.currentPagination.size);
    this.$session.set("limitPaginationDistributions", this.currentPagination.size);

    if (this.$session.get("iWasInPageDistributions") === undefined) {
      this.$session.set("iWasInPageDistributions", 1);
    }
    this.currentPagination.page = this.$session.get('iWasInPageDistributions');
    if(this.$session.get("limitPaginationDistributions") !== undefined){
      this.currentPagination.size = this.$session.get("limitPaginationDistributions");
    }
    this.$session.set("limitPagination", this.currentPagination.size);

    this.$session.set("iWasInPage", 1);
    this.$session.set("iWasInPageNetworks", 1);
    this.$session.set("iWasInPagePlaylist", 1);
    this.$session.set("iWasInPageSeries", 1);
    this.$session.set("iWasInPageUserActivity", 1);
    this.$session.set("iWasInPageDomains", 1);
    this.$session.set("iWasInPageLicences", 1);
    this.$session.set("iWasInPageVideoSources", 1);
    this.search();
  },
  watch: {
    currentPagination(newValue, oldValue) {
      if (newValue.size !== oldValue.size) {
        this.currentPagination.page = 1
        this.search()
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 10px;
  width: 80vw;
  margin: auto !important;
  margin-top: 20px !important;
  border-radius: 10px;
  box-shadow: 1px 1px 20px 5px rgba(0, 0, 0, 0.2);
}

.searchContainer {
  flex: none;
}

.iconContainer {
  margin-right: 15px;
}

.filters {
  padding: 2px 20px;
}

.md-table {

  .md-sortable.md-sorted,
  .md-sortable:hover {
    color: #0198cf;
  }
}

#no-results {
  display: flex;
  padding: 20px;
  .message{
    margin: auto;
  }
  .md-icon {
    margin-right: 5px;
  }

}

.styleRow p {
  font-weight: 600;
}

.rowElements {
  flex: 1;
  padding: 6px 32px 6px 24px;
}

.colorHover:hover {
  background-color: #eee;
}


.titleLine {
  padding: 0px;
  border-bottom: 1 px solid rgba(153, 155, 155, 0.486);
}

.sortable:hover {
  cursor: pointer;
  color: #0198cf;
}</style>



// WEBPACK FOOTER //
// src/shared-components/distribution/DistributionTable.vue